import { componentsConfig as defaultConfig } from "srs.sharedcomponents/lib/esm/components/config";
import ProductListComponent from "srs.sharedcomponents/lib/esm/shared-components/srs.productList.component";
const componentsConfig = { ...defaultConfig, 
    HomePage: ProductListComponent
 };

export { componentsConfig };